@if (_design === 'NEWORDERFLOW') {
  @if (!couponcodeCtrl.disabled) {
    <div  class="flex flex-row flex-nowrap couponcodeinput">
      <div class="form-field w-full" [ngClass]="{'mt-[0]': useRecipefirstStyle}">
        <label [ngClass]="{'text-[1rem] mb-[0.5rem] block': useRecipefirstStyle}">{{'couponcode.do_you_have_a_couponcode' | translate}}</label>
        <div class="flex flex-row mt-1" [ngClass]="{'gap-[0.75rem]': useRecipefirstStyle}">
          <input
            [formControl]="couponcodeCtrl"
            [class]="scheme[colorscheme] + ' focus:ring-0 mt-0 rounded-r-none ' + (useRecipefirstStyle ? 'h-[2.25rem] pl-[1rem]' : 'h-12')"
            (keydown.enter)="false"
            id="couponcode"
            name="{{'couponcode.couponcode' | translate}}"
            type="text"
            >
          <button (click)="checkCouponcode()" [disabled]="!couponcodeCtrl.valid" [ngClass]="{'h-[2.25rem] py-0 text-[0.75rem]': useRecipefirstStyle, 'cursor-pointer': couponcodeCtrl.valid}" class="button-base rounded-lg">
            {{'common.add' | translate}}
          </button>
        </div>
        @if (couponcodeError) {
          <span [ngClass]="{'text-[1rem]': useRecipefirstStyle, 'error': true}" [@collapse]>{{'validation.couponcode_invalid' | translate}}</span>
        }
      </div>
    </div>
  }
}

@if (_design === 'OLD') {
  @if (!couponcodeCtrl.disabled) {
    <div class="flex flex-col couponcodeinput" [ngClass]="{'justify-center' : showSmallButton, 'justify-start' : !showSmallButton }" @collapse>
      @if (showSmallButton) {
        <div class="">
          <button (click)="showCouponcode= !showCouponcode" class="flex flex-wrap justify-between button-base px-6 rounded-full" [disabled]="_disabled">
            <small>
              {{'couponcode.i_have_a_couponcode'| translate}}
            </small>
          </button>
        </div>
      }
      @if (!showSmallButton) {
        <div class="flex flex-row flex-nowrap justify-end">
          @if (!showCouponcode) {
            <button (click)="showCouponcode = true" @horCollapse class="whitespace-nowrap button-base flex button-mid rounded-full relative" [disabled]="_disabled">
              {{'couponcode.i_have_a_couponcode'| translate}}
              <img class="h-3 my-auto ms-2" src="./assets/images/icons/chevron.svg" />
            </button>
          }
          @if (showCouponcode) {
            <button (click)="showCouponcode = false" @horCollapse class="button-base flex rounded-full relative" [disabled]="_disabled">
              {{'common.cancel_button'| translate}}
              <img class="h-3 my-auto ms-2" src="./assets/images/icons/chevron.svg" />
            </button>
          }
        </div>
      }
      <div [@slideInOut]="showCouponcode" class="flex flex-col justify-between px-0 pb-3 gx-1 max-w-[250px]">
        <div class="form-field mx-1">
          <label>{{'couponcode.couponcode' | translate}}</label>
          <input [formControl]="couponcodeCtrl" class="{{scheme[colorscheme]}} " (keydown.enter)="false" id="couponcode" name="{{'couponcode.couponcode' | translate}}" placeholder="{{'couponcode.couponcode' | translate}}" type="text">
          @if (couponcodeError) {
            <span class="error" [@collapse]>{{'validation.couponcode_invalid' | translate}}</span>
          }
        </div>
        <button (click)="checkCouponcode()" [disabled]="!couponcodeCtrl.valid" class="button-base rounded-full mt-[15px] disabled:opacity-25" [ngClass]="{'cursor-pointer': couponcodeCtrl.valid}">
          {{'common.add' | translate}}
        </button>
      </div>
    </div>
  }
}
